// extracted by mini-css-extract-plugin
export default {"btns":"todays-ledger_btns__0f-VL","search":"todays-ledger_search__O-kRv","select_all":"todays-ledger_select_all__NqDjd"};